module.exports = __webpack_public_path__ + "img/blanket_7.e5ba0471.png";